var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNivel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24.5,
    r: 24.5,
    fill: "#212121"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6484 16H30.7526C29.7631 16 28.9609 16.8022 28.9609 17.7917V30.3333C28.9609 31.3228 29.7631 32.125 30.7526 32.125H31.6484C32.6379 32.125 33.4401 31.3228 33.4401 30.3333V17.7917C33.4401 16.8022 32.6379 16 31.6484 16Z",
    fill: "#6796CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.168 21.375H24.2721C23.2826 21.375 22.4805 22.1772 22.4805 23.1667V30.3333C22.4805 31.3228 23.2826 32.125 24.2721 32.125H25.168C26.1575 32.125 26.9596 31.3228 26.9596 30.3333V23.1667C26.9596 22.1772 26.1575 21.375 25.168 21.375Z",
    fill: "#6796CF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6875 27.6465H17.7917C16.8022 27.6465 16 28.4486 16 29.4382V30.334C16 31.3235 16.8022 32.1257 17.7917 32.1257H18.6875C19.677 32.1257 20.4792 31.3235 20.4792 30.334V29.4382C20.4792 28.4486 19.677 27.6465 18.6875 27.6465Z",
    fill: "#6796CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNivel);
export default __webpack_public_path__ + "static/media/IconNivel.1fef8a5ddd15cd80e0f31747b2b7cfc0.svg";
export { ForwardRef as ReactComponent };